import { render, staticRenderFns } from "./TeachingFilter.vue?vue&type=template&id=dd957af8&scoped=true"
import script from "./TeachingFilter.vue?vue&type=script&lang=js"
export * from "./TeachingFilter.vue?vue&type=script&lang=js"
import style0 from "./TeachingFilter.vue?vue&type=style&index=0&id=dd957af8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd957af8",
  null
  
)

export default component.exports